var _module = require('../../components/module');

require('angular-ui-bootstrap/src/modal');
require('../lr-touch');
require('../../components/window-height');

_module.requires.push('ui.bootstrap.module.modal');

_module.service('$deleteFilterModal', [
    '$log',
    '$uibModal',
    '$timeout',

    function $deleteFilterModalService($log, $uibModal, $timeout) {
        /*
        @function openFirstFilterModal
        */
        return function openDeleteFilterModal(sfilter) {
            var modal = $uibModal.open({
                animation: false,
                template: require('./index.html'),
                controller: ['$scope', function deleteFilterModalCtrl($scope) {
                    var init = function () {
                        $scope.sfilter = JSON.parse(JSON.stringify(sfilter));
                    };

                    init();
                }],
                backdrop: true,
                windowClass: 'delete-filter-modal'
            });

            return modal.result;
        };
    }
]);
